import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import WhatsAppButton from "@/components/WhatsAppButton";
import StickyActionBar from "@/components/StickyActionBar";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1 pb-16 md:pb-0">
        <Suspense fallback={<div className="min-h-[60vh]" data-testid="route-loading" />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
      <StickyActionBar />
      <WhatsAppButton />
      <ChatWidget />
    </div>
  );
}
